import script from "./InvoiceDownstreamAllocationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceDownstreamAllocationDialog.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceDownstreamAllocationDialog.vue?vue&type=style&index=0&id=24dded7f&scoped=true&lang=css"
import "./InvoiceDownstreamAllocationDialog.vue?vue&type=style&index=1&id=24dded7f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24dded7f"]])

export default __exports__